import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import {db} from "@src/services/db";

type ExpirationSessionEventPayload = {
    session_id: number;
    is_expired: boolean;
    updated_at?: string;
};

export const ExpirationSessionListener = () => {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();
    if (!auth.user?.id) {
        return
    }

    //@ts-ignore
    window.websockets.private(`user.${auth.user?.id}`).listen(".ExpirationSessionEvent", async (event: ExpirationSessionEventPayload) => {
        try {
            const sessionId = event.session_id;
            await db.sessions.update(sessionId, {
                is_expired: event.is_expired,
                updated_at: Date.now(),
            } as any);
            if (sessionStore.selectedSession?.id === sessionId) {
                sessionStore.selectedSession.is_expired = event.is_expired
            }
        } catch (e) {
            console.error('Erro ao atualizar expiração da sessão', e)
        }
    })
}